export default {
  install(Vue) {
    Vue.prototype.$env = process.env;
  }
};